import React from 'react';
import { ResponsiveContainer, PieChart, Pie, Cell, Legend, Tooltip } from 'recharts';
import PropTypes from 'prop-types';
import { Stack, Typography } from '@mui/material';

const MixPieChart = ({ data, type = 'value' }) => {

    const COLORS = ['#FF8042', '#FFBB28', '#919076', '#0088FE', '#00C49F',];

    return (
        <ResponsiveContainer width="100%" height={300}>
            <PieChart>
                <Pie
                    data={data}
                    // cx={120}
                    // cy={200}
                    innerRadius={60}
                    outerRadius={85}
                    fill="#8884d8"
                    paddingAngle={type === 'rata' ? 0 : 5}
                    dataKey="value"
                >
                    {
                        type === 'rata' ? (
                            data.map((entry, index) => (
                                <Cell key={`cell-${index}`} fill={entry.name === 'Rata-rata' ? '#198754' : '#d9d5d5'} />
                            ))
                        ) : (
                            data.map((entry, index) => (
                                <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                            ))
                        )
                    }
                </Pie>
                
                <Legend />
                <Tooltip content={<CustomTooltip />} />
            </PieChart>
        </ResponsiveContainer>
    );
};

export default MixPieChart;

const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
        return (
            <Stack bgcolor={'rgba(255,255,255,0.9)'} padding={4} borderRadius={2} boxShadow={'0 4px 10px 0 rgba(0,0,0,.25)'} borderColor={'transparent !important'}>
                <Typography variant='h4' fontWeight={'bold'}>{payload[0].name}: {payload[0].value}</Typography>
            </Stack>
        );
    }

    return null;
};

CustomTooltip.propTypes = {
    active: PropTypes.any,
    payload: PropTypes.any,
    label: PropTypes.any,
}

MixPieChart.defaultProps = {
    data: [],
};

MixPieChart.propTypes = {
    data: PropTypes.array,
    type: PropTypes.string
};
